import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { REACT_APP_DOMAIN } from "../../constants";
import { META_TAGS } from "./MetaTags";
import { HandleFallBackUrlsContext } from '../../context/HandleFallBackUrlsContext';
import Spinner from "../Spinner/Spinner";

interface IHelmetWrapper {
  Component:
  | React.LazyExoticComponent<React.ComponentType<any>>
  | React.ComponentType<any>;
}

const HelmetWrapper: React.FC<IHelmetWrapper> = ({
  Component: RouteComponent,
}) => {
  const { pathname } = useLocation();
  const { handleFallBackUrlsLoading } = useContext(HandleFallBackUrlsContext);

  if (handleFallBackUrlsLoading) {
    return <Spinner lightBg={true} />;
  }

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href={`${REACT_APP_DOMAIN}${pathname || ""}`}
        />
        {META_TAGS.hasOwnProperty(pathname) &&
          META_TAGS[pathname].length > 0 &&
          META_TAGS[pathname]}
      </Helmet>
      <RouteComponent />
    </>
  );
};

export default HelmetWrapper;
